var render, staticRenderFns
import script from "./finish-cost-picture.vue?vue&type=script&lang=js"
export * from "./finish-cost-picture.vue?vue&type=script&lang=js"
import style0 from "./finish-cost-picture.vue?vue&type=style&index=0&id=a1d33e60&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports